import { useState } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import {
    Container,
    TextField,
    Button,
    Typography,
    Paper,
    Box,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import logo from '../../../assets/logmed_logo.png';

const OrganisationInput = ({ onOrgIdSaved }) => {
    const [storedOrgId, setStoredOrgId] = useLocalStorage('orgId', null);
    const [orgId, setOrgId] = useState(storedOrgId || '');

    // Responsive design
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleSave = () => {
        setStoredOrgId(orgId);
        onOrgIdSaved(orgId);
    };

    // Organization form content
    const organizationFormContent = (
        <>
            <Typography
                variant="h5"
                gutterBottom
                sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem' } }}
            >
                Ange kund-ID
            </Typography>
            <TextField
                fullWidth
                label="Kundnummer"
                variant="outlined"
                value={orgId}
                onChange={(e) => setOrgId(e.target.value)}
                margin="normal"
            />
            <Button
                variant="contained"
                color="primary"
                onClick={handleSave}
                sx={{
                    mt: 2,
                    py: { xs: 1.5, sm: 2 },
                    width: { xs: '100%', sm: 'auto' },
                }}
            >
                Spara
            </Button>
        </>
    );

    return (
        <Container component="main" maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: { xs: 2, sm: 4 },
                }}
            >
                <img
                    src={logo}
                    alt="Logmed Logo"
                    style={{
                        maxWidth: isMobile ? '60%' : '80%',
                        height: 'auto',
                    }}
                />
            </Box>
            {isMobile ? (
                // Mobile version without Paper
                <Box
                    sx={{
                        marginTop: 3,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    {organizationFormContent}
                </Box>
            ) : (
                // Desktop version with Paper
                <Paper
                    elevation={3}
                    sx={{
                        marginTop: 5,
                        padding: { sm: 4, md: 8 },
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: '100%',
                        boxSizing: 'border-box',
                    }}
                >
                    {organizationFormContent}
                </Paper>
            )}
        </Container>
    );
};

export default OrganisationInput;
